export const openingTime = {
  1: 18, // monday 
  2: 18, // tuesday
  3: 18, // wednesday
  4: 18, // thursday
  5: 14, // friday
  6: 14, // saturday
  0: 14, // sunday
};
